import { DatePicker } from 'antd';
import { FilterComponent } from './FilterComponent';
import { FORMATS } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import React from 'react';
function getDateRangeLabel(values) {
    var _a, _b;
    if (!values || !values.length) {
        return null;
    }
    const start = (_a = values[0]) === null || _a === void 0 ? void 0 : _a.format(FORMATS.SHORT_DATE);
    const end = (_b = values[1]) === null || _b === void 0 ? void 0 : _b.format(FORMATS.SHORT_DATE);
    if (!start && !end) {
        return null;
    }
    return `${start} - ${end}`;
}
export const DateFilter = (props) => {
    const { format, id, onChange, value } = props;
    return (React.createElement(FilterComponent, Object.assign({}, props, { className: 'date', tagProps: {
            value: getDateRangeLabel(value)
        } }),
        React.createElement(DatePicker.RangePicker, { allowClear: true, allowEmpty: [true, true], className: 'filter', format: FORMATS.SHORT_DATE, getPopupContainer: getDirectParent, id: getFilterId(id), onChange: (dates) => {
                onChange({
                    [id]: {
                        format,
                        value: dates
                    }
                });
            }, showTime: false, value: value })));
};
